export interface TronGetContractParamsOptions {
    fromAddress?: string;
    receiverAddress: string;
}
